export default __webpack_public_path__ + "static/media/higher_earning_potential.a1c2a7c2.png";